export const I18N_MODULES: string[] = [
  'ics-core',
  'ics-authentication',
  'ics-theme',
  'ics-data-grid',
  'article-groups',
  'articles',
  'external-api',
  'handling-units',
  'initiator',
  'inventory',
  'lock',
  'material-requests',
  'routing',
  'storage-areas',
  'storage-bins',
  'super-tasks',
  'transport-positions',
  'transport-tasks',
  'user-feedback',
  'warehouses',
  'system-logs',
  'ics-cdk-messenger',
  'ics-ng-messenger',
];
